import { render, staticRenderFns } from "./GocardlessSubscription.vue?vue&type=template&id=2728e35d"
import script from "./GocardlessSubscription.vue?vue&type=script&lang=js"
export * from "./GocardlessSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports